module.exports = __webpack_public_path__ + "static/media/ehealth_website_banner_mobile.f54f272c.jpg";